import Swal, { SweetAlertOptions } from 'sweetalert2'

export const notifyIncident = (payload: {
  data: {
    carerName: any
    residentId: any
    residentName: any
    itemName: any
    description: any
  }
  notification: { title: any }
}) => {
  const { carerName, residentId, residentName, itemName, description } =
    payload.data
  const { title } = payload.notification
  let text
  if (itemName.match(/ABC/)) {
    text = `${residentName} has had an antisocial incident.`
  }
  if (itemName.match(/Fall/)) {
    text = `${residentName} has had a fall.`
  }
  if (itemName.match(/Assault/)) {
    text = `${residentName} has been involved in an assault.`
  }
  if (itemName.match(/Medication/)) {
    text = `${residentName} has had a medication error.`
  }
  if (itemName.match(/Missing/)) {
    text = `${residentName} has been reported as missing.`
  }
  if (itemName.match(/Illness/)) {
    text = `${residentName} has been reported as ill.`
  }
  if (itemName.match(/Injury/)) {
    text = `${residentName} has had an injury.`
  }
  if (itemName.match(/Seizure/)) {
    text = `${residentName} has had a seizure.`
  }
  if (itemName.match(/Custom/)) {
    text = `An incident was logged regarding ${residentName}.`
  }

  const html = `
      <div style="font-weight: 400">
        <p>${text || ''}</p>
        <p>"${description}"</p>
        <p>Logged by: ${carerName}</p>
        <a href="https://careoffice.logmycare.co.uk/residents/${residentId}/charts/incident">
          <button class="lmc-custom-notification-view-more">
            View More
          </button>
        </a>
      </div>
    `

  Swal.fire({
    title,
    html,
    type: 'warning',
    showConfirmButton: false,
    showCloseButton: true,
  } as SweetAlertOptions)
}
